import type { WriteOffDiscrepancy } from '@shared/api';
import { fmtNum } from '@shared/lib/smetaLabels';

export function statusTone(status: string): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  switch (status) {
    case 'completed':
      return 'success';
    case 'processing':
      return 'info';
    case 'pending':
      return 'warning';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function statusLabel(status: string): string {
  switch (status) {
    case 'completed':
      return 'готово';
    case 'processing':
      return 'анализ…';
    case 'pending':
      return 'в очереди';
    case 'failed':
      return 'ошибка';
    default:
      return status;
  }
}

export function discrTone(sev: string): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  switch (sev) {
    case 'critical':
      return 'danger';
    case 'major':
      return 'warning';
    case 'minor':
      return 'info';
    default:
      return 'neutral';
  }
}

export function kindLabel(kind: string): string {
  switch (kind) {
    case 'overspend':
      return 'перерасход';
    case 'saving':
      return 'экономия';
    case 'fact_no_norm':
      return 'без основания';
    case 'norm_no_fact':
      return 'без факта';
    case 'unit_mismatch':
      return 'единицы';
    default:
      return kind;
  }
}

export function fmtDelta(d: WriteOffDiscrepancy): string {
  if (d.delta_quantity === null || d.delta_quantity === undefined) return '—';
  const pct =
    d.delta_pct !== null && d.delta_pct !== undefined ? ` (${d.delta_pct.toFixed(1)}%)` : '';
  return `${fmtNum(d.delta_quantity)}${pct}`;
}

export function extractFailedSources(summary: unknown): {
  failedSources: string[];
  totalFiles: number | null;
  hasUnparsedKs2: boolean;
} {
  if (!summary || typeof summary !== 'object') {
    return { failedSources: [], totalFiles: null, hasUnparsedKs2: false };
  }
  const rec = summary as Record<string, unknown>;
  const rawList = Array.isArray(rec.failed_sources) ? rec.failed_sources : [];
  const failedSources = rawList
    .filter((v): v is string => typeof v === 'string' && v.trim().length > 0)
    .map((v) => v.trim());
  const totalFiles =
    typeof rec.files === 'number' && Number.isFinite(rec.files) ? rec.files : null;
  const ks2FailedCount =
    typeof rec.ks2_failed_count === 'number' && Number.isFinite(rec.ks2_failed_count)
      ? rec.ks2_failed_count
      : null;
  // Для новых расчётов блокируем отправку претензии/риска именно при неразобранных
  // КС-2 (нормативы неполные); для прежних записей без ks2_failed_count — консервативно
  // при наличии любых failed_sources.
  const hasUnparsedKs2 = ks2FailedCount !== null ? ks2FailedCount > 0 : failedSources.length > 0;
  return { failedSources, totalFiles, hasUnparsedKs2 };
}
